import React from 'react';
import { connect } from 'react-redux';
import { signOut } from '../../store/actions/auth-actions';
import { useResources } from '../../utility/use-resources';
import { NavLink } from '../commons/link';
import LoginForm from '../login/login-form';
import OutsideClickHandler from 'react-outside-click-handler'
import { checkParent } from '../../utility/check-parent';

const MiniUserArea = props => {
  const { uid, close, open, profile } = props
  const [r] = useResources("user-area");

  const onOutsideClick = (e) => {
    const button = document.querySelector('.user-button')
    if (checkParent(button, e.target)) {
      return
    }
    close()
  }

	return (
    <OutsideClickHandler onOutsideClick={onOutsideClick}>
      <div className="menu-sidebar mini-user-area">
        <div className="sidebar-title">
          <p className='h6'><b>{uid ? `Welcome, ${profile.firstName}` : "Login"}</b></p>
        </div>
        <button className="sidebar-close" onClick={close}><i /></button>
        <div className='sidebar-wrapper'>
          {uid 
            ? (
              <>
                <div className='user-area-main-links'>
                  {r('mainLinks').map(link => (
                    <li>
                      <NavLink
                        tabIndex={open ? "" : "-1"}
                        exact
                        onClick={close}
                        to={link.url}
                      >
                        <p className="h4">{link.name}</p>
                      </NavLink>
                    </li>
                  ))}
                </div>
                <div className='user-area-secondary-links'>
                  {r('secondaryLinks').map(link => (
                    <li>
                      <NavLink
                        tabIndex={open ? "" : "-1"}
                        exact
                        onClick={close}
                        to={link.url}
                      >
                        <p className="h6">{link.name}</p>
                      </NavLink>
                    </li>
                  ))}
                </div>
                <div style={{ textAlign: 'center', marginTop: '40px' }}>
                  <button
                    className="link-primary link-outline"
                    onClick={() => props.signOut()}
                  >
                    Logout
                  </button>
                </div>
              </>
            )
            : <LoginForm close={close} />}
        </div>
      </div>
    </OutsideClickHandler>
	);
}

export default connect(
  undefined,
  (dispatch) => ({
    signOut: () => dispatch(signOut()),
  })
)(MiniUserArea);
